<script lang="ts" setup>
import type { CascaderProps } from 'ant-design-vue';
import { Cascader as ACascader } from 'ant-design-vue';
import { computed, useAttrs, useSlots } from 'vue';
import { get } from 'lodash-es';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';
import useSlot from '../../hooks/useSlot';
import type { FormConfig } from '../../form/types';

const { getBindValue } = useForm<CascaderProps & FormConfig>({ componentName: 'cascader', attrs: useAttrs() });

const { useExcludeSlots } = useSlot({ slots: useSlots() }, []);

const showData = computed(() => {
  const { options, value, fieldNames = { label: 'label', value: 'value', children: 'children' } } = getBindValue.value;
  let _options = options;
  return typeof value === 'string'
    ? [value]
    : value?.map((e, i) => {
        const item = _options?.find(v => get(v, fieldNames.value as string) === e);
        _options = get(item, fieldNames.children as string);
        return item;
      });
});

function showValue() {
  return showData.value?.map(e => get(e, getBindValue.value.fieldNames?.label || 'label')).join('/');
}
</script>

<script lang="ts">
export default {
  name: 'Cascader',
};
</script>

<template>
  <span
    v-if="getBindValue?.readOnly"
    :class="getBindValue?.readOnlyClassName"
    :style="getBindValue?.readOnlyStyle ? getBindValue?.readOnlyStyle : {}"
    ><slot v-if="readOnlySlot in $slots" :name="readOnlySlot" :text="getBindValue.value" :data="showData">{{
      showValue()
    }}</slot
    ><template v-else>{{ showValue() }}</template></span
  >
  <ACascader v-else v-bind="getBindValue">
    <template v-for="(slot, key) in useExcludeSlots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </ACascader>
</template>
